import { AccordionSummary, Box, styled } from '@mui/material';
import Accordion, {
  AccordionDetails,
  StyledAccordion,
} from 'new/components/Accordion';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { commonLandingPageStyles } from '../../styles';
import { LandingPageCommonProps } from '../../types';
import { getPlanTypeFormatMessageProps } from '../../utils';
import { useExternalPatientsStore } from '../../hooks';
import { TENANT } from 'new/tenants';

const Wrapper = styled(Box)(() => ({
  color: 'white',
  width: '90%',
  maxWidth: '1000px',
  margin: '2rem auto',
  padding: '2rem 0',
  display: 'block',
  borderRadius: '10px',
  '.faq-title': {
    fontSize: '2rem',
    fontWeight: 'bold',
    textAlign: 'center',
    paddingBottom: '2rem',
    '-webkit-font-smoothing': 'antialiased',
  },
}));
const SummaryComponent = styled(AccordionSummary)(({ theme }) => ({
  ...commonLandingPageStyles,
  color: theme.palette.common.white,
}));

const DetailsComponent = styled(AccordionDetails)(({ theme }) => ({
  ...commonLandingPageStyles,
  paddingLeft: '2.5rem',
  color: theme.palette.common.white,
  // fontSize: '110%',
  fontWeight: 'bold',
}));

const getAccordionComponent = (colorOneHex: string) =>
  styled(StyledAccordion)(({ theme }) => ({
    '&.MuiAccordion-root': {
      ...commonLandingPageStyles,
      '&.Mui-expanded, &:hover': {
        background: 'rgba(0,0,0,.1)',
      },
      color: theme.palette.common.white,
      background: colorOneHex,
      borderRadius: 0,
      border: 'none',
      borderTop: '1px solid rgba(0,0,0,.1)',
      marginBottom: 0,
    },
    '.MuiAccordionSummary-expandIconWrapper': {
      display: 'none',
    },
  }));

type Props = LandingPageCommonProps;

const FAQ: React.FC<Props> = ({ colorOneHex, nearbyZipcodes, cityState }) => {
  const { planType } = useExternalPatientsStore();
  const [expanded, setExpanded] = useState<string>();
  const intl = useIntl();

  const onChange = (name: string, isExpanded: boolean) => {
    if (isExpanded) {
      setExpanded(name);
    } else {
      setExpanded(undefined);
    }
  };
  return (
    <Wrapper component="section" sx={{ backgroundColor: colorOneHex }}>
      <div className="faq-title">{intl.formatMessage({ id: 'label.faq' })}</div>
      {Array.from(Array(TENANT.faqLength)).map((_, index) => (
        <Accordion
          name={`landingFaq${index}`}
          expanded={expanded === `landingFaq${index}`}
          handleChange={onChange}
          summary={intl.formatMessage(
            index === 6
              ? getPlanTypeFormatMessageProps(
                  `signup.externalLanding.faq.question${index + 1}`,
                  planType,
                )
              : {
                  id: `signup.externalLanding.faq.question${index + 1}`,
                },
            { nearbyZipcodes: nearbyZipcodes, cityState: cityState },
          )}
          details={intl.formatMessage(
            index === 6
              ? getPlanTypeFormatMessageProps(
                  `signup.externalLanding.faq.answer${index + 1}`,
                  planType,
                )
              : {
                  id: `signup.externalLanding.faq.answer${index + 1}`,
                },
            { nearbyZipcodes: nearbyZipcodes, cityState: cityState },
          )}
          summaryComponent={SummaryComponent}
          detailsComponent={DetailsComponent}
          accordionComponent={getAccordionComponent(colorOneHex)}
        />
      ))}
    </Wrapper>
  );
};

export default FAQ;
